import { identity, join, map } from 'lodash/fp';

import { PAYMENT_FREQUENCY_LABEL } from '../../ahm-constants/ui';
import { PAYMENT_FREQUENCY_OPTIONS } from '../../models/price/constants';

type GetFrequencyOptionsProps = {
  format?: (value: string) => string;
  endText?: string;
};

const getFrequencyOptions = ({ format = identity, endText }: GetFrequencyOptionsProps = {}) =>
  map(
    (frequency) => ({
      text: join('', [format(PAYMENT_FREQUENCY_LABEL[frequency]), endText]),
      value: frequency,
    }),
    PAYMENT_FREQUENCY_OPTIONS,
  );

export default getFrequencyOptions;
